import React, { Component } from 'react';
import config from '../../../config';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import myConfigRoutes from './../../../route-component';
import trackEventsObj from './../../../constants/new-pageTrackEvents';
import { Redirect, withRouter } from 'react-router-dom';
import { closeDynamicCard } from './../../../actions/AppActions';
import { connect } from 'react-redux';

class DynamicCards extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = (dynamicCard) => {
    if (dynamicCard.inAppRedirect) {
      let routeObj = myConfigRoutes.find(
        (route) => route.name === dynamicCard.buttonRedirectPage
      );
      if (dynamicCard.dismissOnButton) {
        this.props.closeDynamicCard(dynamicCard);
      }
      this.props.onRedirectTo(routeObj.path_);
    } else {
      const url = dynamicCard.buttonRedirectLink;
      if (dynamicCard.dismissOnButton) {
        this.props.closeDynamicCard(dynamicCard);
      }
      window.open(url);
    }
  };

  linkClick = (dynamicCard) => {
    const url = dynamicCard.descLink;
    window.open(url);
  };

  onClickClose = (dynamicCard) => {
    // let cardStatus = common.getLocalStorage('dynamicCard');
    // let objIndex = cardStatus.findIndex(
    //   (card) =>
    //     card.persistKey === dynamicCard.persistKey &&
    //     card.version === dynamicCard.version
    // );
    // if (objIndex >= 0) {
    //   cardStatus[objIndex].isDisabled = true;
    //   common.setLocalStorage('dynamicCard', cardStatus);
    // }
    this.props.closeDynamicCard(dynamicCard);
  };

  render() {
    let trans = this.props.trans;
    let dynamicCards = this.props.dynamicCards;
    return dynamicCards.map((dynamicCard, index) => {
      // let cardStatus = common.getLocalStorage('dynamicCard');
      // if (!cardStatus) {
      //   let cardArray = [];
      //   if (dynamicCard.isDismissible) {
      //     let cardObject = {
      //       persistKey: dynamicCard.persistKey,
      //       version: dynamicCard.version,
      //       isDisabled: false,
      //     };
      //     cardArray.push(cardObject);
      //     common.setLocalStorage('dynamicCard', cardArray);
      //   }
      // } else {
      //   if (dynamicCard.isDismissible) {
      //     let objIndex = cardStatus.findIndex(
      //       (card) => card.persistKey === dynamicCard.persistKey
      //     );
      //     if (objIndex < 0) {
      //       let cardObject = {
      //         persistKey: dynamicCard.persistKey,
      //         version: dynamicCard.version,
      //         isDisabled: false,
      //       };
      //       cardStatus.push(cardObject);
      //       common.setLocalStorage('dynamicCard', cardStatus);
      //     } else {
      //       if (cardStatus[objIndex].version !== dynamicCard.version) {
      //         let cardObject = {
      //           persistKey: dynamicCard.persistKey,
      //           version: dynamicCard.version,
      //           isDisabled: false,
      //         };
      //         cardStatus[objIndex] = cardObject;
      //         common.setLocalStorage('dynamicCard', cardStatus);
      //       } else {
      //       }
      //     }
      //   }
      // }

      return !dynamicCard.isDisabled && dynamicCard.isVisible ? (
        <div
          key={index}
          className={
            'si-card si-card__eot ' + (dynamicCard.isUrgent ? 'si-urgent' : '')
          }>
          <div className='si-card__eot-ct'>
            {dynamicCard.isDismissible ? (
              <div
                className='si-close-card'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  this.onClickClose(dynamicCard);
                }}></div>
            ) : (
              ''
            )}
            <div className='si-mt-text-title'>
              {trans[dynamicCard.titleTrans] || ''}
            </div>
            {dynamicCard.desc1Trans ? (
              <div className='si-text-descp'>
                {trans[dynamicCard.desc1Trans] || ''}
              </div>
            ) : (
              ''
            )}

            <div className='si-text-descp'>
              {dynamicCard.desc2Part1Trans
                ? trans[dynamicCard.desc2Part1Trans] + ' '
                : ''}
              {dynamicCard.descLinkTrans ? (
                <a
                  onClick={() => {
                    this.linkClick(dynamicCard);
                  }}>
                  {trans[dynamicCard.descLinkTrans] + ' '}
                </a>
              ) : (
                ''
              )}
              {dynamicCard.desc2Part2Trans
                ? trans[dynamicCard.desc2Part2Trans]
                : ''}
            </div>
            {dynamicCard.hasButton ? (
              <div className='button-block'>
                <div
                  className='si-btn btn-lg'
                  onClick={() => {
                    this.handleClick(dynamicCard);
                  }}>
                  {trans[dynamicCard.buttonTrans] || ''}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      ) : null;
    });
  }
}

export default DynamicCards;



// WEBPACK FOOTER //
// ./src/components/home/cards/DynamicCards.js